import { HttpEventType } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute } from '@angular/router';
import { FormlyFieldConfig, FormlyFormOptions } from '@ngx-formly/core';
import { FormlyJsonschema } from '@ngx-formly/core/json-schema';
import { from, Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { Company } from 'src/app/model/company';
import { User } from 'src/app/model/user';
import { AuthService } from 'src/app/services/auth.service';
import { CompaniesService } from 'src/app/services/companies.service';
import {Tester} from "../../../model/tester";
import { error } from 'console';

@Component({
  selector: 'aw-add-test-image',
  templateUrl: './add-test-image.component.html',
  styleUrls: ['./add-test-image.component.scss']
})
export class AddTestImageComponent implements OnInit {

  currentTestFile?: File;
  currentJsonInputFile?: File;
  currentJsonOutputSchemaFile?: File;

  progressTestFile = 0;
  progressJsonInputFile = 0;
  progressJsonOuputSchemaFile = 0;

  messageTestFile = '';
  messageJsonInputFile = '';
  messageJsonOutputSchemaFile = '';

  completeSubmission: any | null = null;
  finalSubmission: any | null = null;

  fileNameTest = 'Select File';
  fileNameJsonInputSchema = 'Select File';
  fileNameJsonOutputSchema = 'Select File';
  fileInfos?: Observable<any>;

  isTestFileUploaded: boolean = false;
  isJsonInputFileUploaded: boolean = false;
  isOutputSchemaFileUploaded: boolean = false;

  testCaseForm: FormGroup;
  scriptDescriptorForm: FormGroup;
  UN_R155_Options = ["Back-end servers used as a means to attack a vehicle or extract data (slt.001)", "Services from back-end server being disrupted, affecting the operation of a vehicle (slt.002)", "Vehicle related data held on back-end servers being lost or compromised ('data breach') (slt.003)", "Spoofing of messages or data received by the vehicle (slt.004)", "Communication channels used to conduct unauthorized manipulation, deletion or other amendments to vehicle held code/data (slt.005)", "Communication channels permit untrusted/unreliable messages to be accepted or are vulnerable to session hijacking/replay attacks (slt.006)", "Information can be readily disclosed. (slt.007)", "Denial of service attacks via communication channels to disrupt vehicle functions (slt.008)", "An unprivileged user is able to gain privileged access to vehicle systems (slt.009)", "Viruses embedded in communication media are able to infect vehicle systems  (slt.010)", "Messages received by the vehicle (for example X2V or diagnostic messages), or transmitted within it, contain malicious content (slt.011)", "Misuse or compromise of update procedures (slt.012)", "It is possible to deny legitimate updates (slt.013)", "Legitimate actors are able to take actions that would unwittingly facilitate a cyber-attack (slt.015)", "Manipulation of the connectivity of vehicle functions enables a cyber-attack (slt.016)", "Hosted 3rd party software (slt.017)", "Devices connected to external interfaces (slt.018)", "Extraction of vehicle data/code (slt.019)", "Manipulation of vehicle data/code (slt.020)", "Erasure of data/code (slt.021)", "Introduction of malware (slt.022)", "Introduction of new software or overwrite existing software (slt.023)", "Disruption of systems or operations (slt.024)", "Manipulation of vehicle parameters (slt.025)", "Cryptographic technologies can be compromised or are insufficiently applied (slt.026)", "Parts or supplies could be compromised to permit vehicles to be attacked (slt.027)", "Software or hardware development permits vulnerabilities (slt.028)", "Network design introduces vulnerabilities (slt.029)", "Physical loss of data loss (slt.030)", "Unintended transfer of data can occur (slt.031)", "Physical manipulation of systems can enable an attack (slt.032)"];
  STRIDE_Options = ["spoofing", "tampering", "repudiation", "information disclosure", "denial of service", "elevation of privilege"];
  CIA_Options = ["confidentiality", "integrity", "availability"];

  REG_ID = /^(?<content>.*?)(?=\s*\((?<id>(?:slt\.\d+|(?:gb|GB)-\d+(?:\.\d+)+))\))/i;
  ///^(?<content>.*?)(?=\s*\((?<id>(?:(?:slt|SLT)\.\d+|(?:gb|GB)-\d+(?:\.\d+)+))\))/
  REG_TEST_FILE = /^(?<testId>[a-z0-9]+)_(?<scriptName>[a-z0-9]+)(?:_(?<schemaType>input|output)_schema\.json|\.tar)$/;
  

  isCIANASelected = false;
  isStrideNASelected = false;
  isUNR155NASelected = false;
  isNoDependeciesDefinedSelected = false;
  isNoDependeciesRequiredSelected = false;

  interfaces: string[] = [];
  targets: string[] = [];
  dependencies: string[] = [];
  testInformation: any[] = [];

  selectionTestInformation: any = null;

  company: Company;
  dependenciesForm = new FormControl<string[] | undefined>([]);

  loggedUser: User = this.authService.loggedUser();
  companyID: number;

  isTestFileUploading: boolean = false;
  isJsonInputFileUploading: boolean = false;
  isOutputSchemaUploading: boolean = false;

  isCreateNewTest: boolean | null =  null;
  

  constructor(
    private fb: FormBuilder,
    private companiesService: CompaniesService,
    private snackbar: MatSnackBar,
    private authService: AuthService,
    private route: ActivatedRoute
  ) { 
    this.route.params.subscribe(params => {
      this.companyID = params['companyId'];
    })
  }

  ngOnInit(): void {

    // this.company = this.authService.loggedUser()?.company;
    this.companiesService.getCompanyById(this.companyID).subscribe(response => {
      this.company = response;

      this.companiesService.getSubmissionInformation(this.company.id).subscribe(response => {
        let res = response as any;
        this.interfaces = res.data.interfaces;
        this.targets = res.data.targetTypes;
        this.dependencies = res.data['dependency-list'];
        this.testInformation = res.data.testInformation;
      });
      
    });

    this.testCaseForm = this.fb.group({
      id: ['', Validators.required],
      title: ['', Validators.required],
      summary: ['', Validators.required],
      testObjectives: ['', Validators.required],
      examples: [''],
      subLevelThreatID: ['', Validators.required],
      stride: ['', Validators.required],
      cia: ['', Validators.required],
      testSetup: ['', Validators.required],
      expectedResult: ['', Validators.required],
      claims: ['', Validators.required],
    });

    this.scriptDescriptorForm = this.fb.group({
      interface: ['', Validators.required],
      target: ['', Validators.required],
      scriptName: ['', Validators.required],
      version: ['', Validators.required],
      scriptDescription: ['', Validators.required]
    });

  }

  onSelectionUNR155Change(event: any) {
    const selectedValues = event.value;

    if (selectedValues.includes('N/A')) {
      this.isUNR155NASelected = true;
      this.testCaseForm.get('subLevelThreatID')?.setValue(['N/A']);
    } else {
      this.isUNR155NASelected = false;
      this.testCaseForm.get('subLevelThreatID')?.setValue(selectedValues);
    }
  }

  onSelectionStrideChange(event: any) {
    const selectedValues = event.value;

    if (selectedValues.includes('N/A')) {
      this.isStrideNASelected = true;
      this.testCaseForm.get('stride')?.setValue(['N/A']);
    } else {
      this.isStrideNASelected = false;
      this.testCaseForm.get('stride')?.setValue(selectedValues);
    }
  }

  onSelectionCIAChange(event: any) {
    const selectedValues = event.value;

    if (selectedValues.includes('N/A')) {
      this.isCIANASelected = true;
      this.testCaseForm.get('cia')?.setValue(['N/A']);
    } else {
      this.isCIANASelected = false;
      this.testCaseForm.get('cia')?.setValue(selectedValues);
    }
  }

  onSelectionTestCreationChange(event: any) {

    this.selectionTestInformation = event.value;

    if (this.selectionTestInformation === 'NEW')
      this.isCreateNewTest = true;
    else 
      this.isCreateNewTest = false;
    
  }

  onSelectionDependeciesChange(event: any) {
    const selectedValues = event.value;

    if (selectedValues.includes('No dependencies required')) {
      this.isNoDependeciesRequiredSelected = true;
      this.isNoDependeciesDefinedSelected = false;
      this.dependenciesForm.setValue(['No dependencies required']);
    }
    else if (selectedValues.includes('No dependencies already defined')) {
      this.isNoDependeciesRequiredSelected = false;
      this.isNoDependeciesDefinedSelected = true;
      this.dependenciesForm.setValue(['No dependencies already defined']);
    } 
    else {
      this.isNoDependeciesRequiredSelected = false;
      this.isNoDependeciesDefinedSelected = false;
      this.dependenciesForm.setValue(selectedValues);
    }

  }

  extractRegulationId(text: string): string | null {

    if (text === 'N/A')
      return 'N/A';

    return this.REG_ID.exec(text)?.groups?.id ?? null;
  }


  onFormSubmit() {

    let testInformation = null;

    if (this.isCreateNewTest)
      testInformation =  this.testCaseForm.value;
    else
      testInformation = {
        id: this.selectionTestInformation,
      };


    if (this.completeSubmission){
      this.completeSubmission = {
        ...this.completeSubmission,
        testInformation: testInformation,
        scriptDescriptor: {
          ...this.scriptDescriptorForm.value,
          userId: this.authService.loggedUser()?.id
        }
      }
    }
    else {
      this.completeSubmission = {
        testInformation: testInformation,
        scriptDescriptor: {
          ...this.scriptDescriptorForm.value,
          userId: this.authService.loggedUser()?.id
        }
      }
    }
    
  }

  onDependenciesSubmit() {
    this.completeSubmission = {
      ...this.completeSubmission,
      dependencies: this.dependenciesForm.value,
    }
    
  }
  
  finalSubmit() {    
    if (this.isTestFileUploaded && this.isJsonInputFileUploaded && this.isOutputSchemaFileUploaded) {

      this.finalSubmission = this.completeSubmission;

      if (this.isCreateNewTest) {
        if (this.finalSubmission.testInformation.cia[0] === 'N/A')
          this.finalSubmission.testInformation.cia = [];
        if (this.finalSubmission.testInformation.subLevelThreatID[0] === 'N/A')
          this.finalSubmission.testInformation.subLevelThreatID = [];
        if (this.finalSubmission.testInformation.stride[0] === 'N/A')
          this.finalSubmission.testInformation.stride = [];
      }

      if (this.finalSubmission.dependencies[0] === 'No dependencies required')
        this.finalSubmission.dependencies = [];
      else if (this.finalSubmission.dependencies[0] === 'No dependencies already defined')
        this.finalSubmission.dependencies = "NOT_AVAILABLE";

      this.finalSubmission = [{...this.finalSubmission}];

      this.companiesService.addTestImage(this.company.id, this.finalSubmission).subscribe(respose => {
          this.snackbar.open("Test uploaded correctly!", 'Ok', {
            duration: 2000
          });        
      }, error => {
          this.snackbar.open("Test NOT uploaded correctly!", 'Ok', {
            duration: 2000
          });
      });
    }
  }
  
  
  selectTestImageFile(event: any): void {
    if (event.target.files && event.target.files[0]) {
      const file: File = event.target.files[0];
      if (file.type === 'application/x-tar') {
        this.currentTestFile = file;
        this.fileNameTest = this.currentTestFile.name;
      }
      else {
        this.snackbar.open("The extension is NOT correct!", 'Ok', {
          duration: 2000
        });
        event.target.value = ''; // reset
      }
    } else {
      this.fileNameTest = 'Select File';
    }
  }

  selectJsonInputImageFile(event: any): void {
    if (event.target.files && event.target.files[0]) {
      const file: File = event.target.files[0];
      if (file.type === 'application/json') {
        this.currentJsonInputFile = file;
        this.fileNameJsonInputSchema = this.currentJsonInputFile.name;
      }
      else {
        this.snackbar.open("The extension is NOT correct!", 'Ok', {
            duration: 2000
        });
        event.target.value = ''; // reset
      }
    } else {
      this.fileNameJsonInputSchema = 'Select File';
    }
  }

  selectOutputSchemaImageFile(event: any): void {
    if (event.target.files && event.target.files[0]) {
      const file: File = event.target.files[0];
      if (file.type === 'application/json') {
        this.currentJsonOutputSchemaFile = file;
        this.fileNameJsonOutputSchema = this.currentJsonOutputSchemaFile.name;
      }
      else {
        this.snackbar.open("The extension is NOT correct!", 'Ok', {
          duration: 2000
        });
        event.target.value = ''; // reset
      }
    } else {
      this.fileNameJsonOutputSchema = 'Select File';
    }
  }

  checkTestFileName(file: File): boolean {

    if (!file) return false;

    const match = file.name.match(this.REG_TEST_FILE);

    if (!match?.groups) {
      this.snackbar.open("The filename or the extension is NOT correct!", 'Ok', {
        duration: 2000
      });
      return false;
    }

    const { testId, scriptName, schemaType } = match.groups as {
      testId: string;
      scriptName: string;
      schemaType?: "input" | "output";
    };
    const underscoreCount = (file.name.match(/_/g) || []).length;
    if (schemaType) {
      if (underscoreCount !== 3) {
        this.snackbar.open("The filename or the extension is NOT correct!", 'Ok', {
          duration: 2000
        });
        return false;
      }
    }else {
      if (underscoreCount !== 1) {
        this.snackbar.open("The filename or the extension is NOT correct!", 'Ok', {
          duration: 2000
        });
        return false;
      }
    }
    // check if testId and scriptName of filename are the same of the form
    if (testId !== this.completeSubmission.testInformation.id ||
        scriptName !== this.completeSubmission.scriptDescriptor.scriptName) {
          this.snackbar.open("testId and scriptName in file name must be the same that you used to fill the form",  'Ok', {
            duration: 2000
          });
          return false;
        }

    return true
  }

  uploadTestFile() {

  
    if(this.currentTestFile) {

      let newFileName = this.completeSubmission.testInformation.id.toLowerCase() + "_" + this.completeSubmission.scriptDescriptor.scriptName.toLowerCase() + ".tar";

      let newCurrentTestFile = new File(
        [this.currentTestFile],
        newFileName,
        { type: this.currentTestFile.type }
      );

      this.companiesService.getUploadSignedUrl(this.company.id, newCurrentTestFile.name, newCurrentTestFile.size).subscribe(response => {
        
        let obs = new Observable<any>();
        obs = from(newCurrentTestFile.arrayBuffer()).pipe(
          switchMap( fileBuffer => {
            return this.companiesService.uploadFile(fileBuffer, newCurrentTestFile.name, newCurrentTestFile.type, response.data.url, response.data.fields)
          })
        );
        
        this.isTestFileUploading = true;

        obs.subscribe(event => {
          if (event.type === HttpEventType.UploadProgress)
            this.progressTestFile = Math.round(100 * event.loaded / event.total!);
          else if (event.type === HttpEventType.Response) {
            this.currentTestFile = null;
            this.snackbar.open('File Uploaded!', 'Close', {
              duration: 2000
            });
            this.isTestFileUploaded = true;
            this.isTestFileUploading = false;
          }
          
        }, error => {
          this.snackbar.open('File NOT Uploaded!', 'Close', {
            duration: 2000
          });
          this.isTestFileUploading = false;
        });

      });
    }

  }


  uploadJsonInputFile() {

    if(this.currentJsonInputFile) {

      let newFileName = this.completeSubmission.testInformation.id.toLowerCase() + "_" + this.completeSubmission.scriptDescriptor.scriptName.toLowerCase() + "_input_schema.json";

      let newJsonInputFile = new File(
        [this.currentJsonInputFile],
        newFileName,
        { type: this.currentJsonInputFile.type }
      );

      this.companiesService.getUploadSignedUrl(this.company.id, newJsonInputFile.name, newJsonInputFile.size).subscribe(response => {

        let obs = new Observable<any>();
        obs = from(newJsonInputFile.arrayBuffer()).pipe(
          switchMap( fileBuffer => {
            return this.companiesService.uploadFile(fileBuffer, newJsonInputFile.name, newJsonInputFile.type, response.data.url, response.data.fields)
          })
        );

        obs.subscribe(event => {
          if (event.type === HttpEventType.UploadProgress)
            this.progressJsonInputFile = Math.round(100 * event.loaded / event.total!);
          else if (event.type === HttpEventType.Response) {
            this.currentJsonInputFile = null;
            this.snackbar.open('File Uploaded!', 'Close', {
              duration: 2000
            });
            this.isJsonInputFileUploaded = true;
          }
          
        }, error => {
          this.snackbar.open('File NOT Uploaded!', 'Close', {
            duration: 2000
          });
        });

      });

    }

  }

  uploadOutputSchemaFile() {

    if(this.currentJsonOutputSchemaFile) {

      let newFileName = this.completeSubmission.testInformation.id.toLowerCase() + "_" + this.completeSubmission.scriptDescriptor.scriptName.toLowerCase() + "_output_schema.json";

      let newJsonOutputFile = new File(
        [this.currentJsonOutputSchemaFile],
        newFileName,
        { type: this.currentJsonOutputSchemaFile.type }
      );

      this.companiesService.getUploadSignedUrl(this.company.id, newJsonOutputFile.name, newJsonOutputFile.size).subscribe(response => {

        let obs = new Observable<any>();
        obs = from(newJsonOutputFile.arrayBuffer()).pipe(
          switchMap( fileBuffer => {
            return this.companiesService.uploadFile(fileBuffer, newJsonOutputFile.name, newJsonOutputFile.type, response.data.url, response.data.fields)
          })
        );

        obs.subscribe(event => {
          if (event.type === HttpEventType.UploadProgress)
            this.progressJsonOuputSchemaFile = Math.round(100 * event.loaded / event.total!);
          else if (event.type === HttpEventType.Response) {
            this.currentJsonOutputSchemaFile = null;
            this.snackbar.open('File Uploaded!', 'Close', {
              duration: 2000
            });
            this.isOutputSchemaFileUploaded = true;
          }
          
        }, error => {
          this.snackbar.open('File NOT Uploaded!', 'Close', {
            duration: 2000
          });
        });

      });

    }

  }

}
